export default "__VITE_PUBLIC_ASSET__1d8b16ff__"